export const NUTRICION_DIAS_ANTERIORES = 10;

export const NUTRICION_MENU_SECTIONS = [
  { key: 'comidas', linksKey: 'comidasLinks', title: 'Comidas habituales', icon: 'bi-sun' },
  { key: 'cenas', linksKey: 'cenasLinks', title: 'Cenas habituales', icon: 'bi-moon' },
  {
    key: 'comidasFinDeSemana',
    linksKey: 'comidasFinDeSemanaLinks',
    title: 'Comidas de fin de semana',
    icon: 'bi-calendar-heart',
  },
  {
    key: 'cenasFinDeSemana',
    linksKey: 'cenasFinDeSemanaLinks',
    title: 'Cenas de fin de semana',
    icon: 'bi-moon-stars',
  },
];

export function normalizeMenuRows(semana, key, linksKey) {
  const items = semana?.[key];
  if (!Array.isArray(items) || !items.length) return [];
  const links = semana?.[linksKey];
  if (Array.isArray(links) && links.length === items.length) {
    return links;
  }
  return items.map((texto) => ({
    texto,
    href: null,
    kind: null,
    id: null,
  }));
}

export function countMenuItems(semana) {
  if (!semana) return 0;
  return NUTRICION_MENU_SECTIONS.reduce(
    (n, section) => n + (Array.isArray(semana[section.key]) ? semana[section.key].length : 0),
    0
  );
}

export function menuSectionsWithRows(semana) {
  return NUTRICION_MENU_SECTIONS
    .map((section) => ({
      ...section,
      rows: normalizeMenuRows(semana, section.key, section.linksKey),
    }))
    .filter((section) => section.rows.length > 0);
}

export function addDaysFecha(fechaStr, n) {
  if (!fechaStr) return '';
  const d = new Date(`${fechaStr}T12:00:00.000Z`);
  d.setUTCDate(d.getUTCDate() + Number(n || 0));
  return d.toISOString().split('T')[0];
}

export function esDiaAnterior(fecha, hoy) {
  return Boolean(fecha && hoy && fecha < hoy);
}

export function diasMenuVisibles(dias, hoy, incluirAnteriores, n = NUTRICION_DIAS_ANTERIORES) {
  const list = Array.isArray(dias) ? dias : [];
  if (!hoy) return list;
  const desde = incluirAnteriores ? addDaysFecha(hoy, -n) : hoy;
  return list.filter((d) => d && typeof d.fecha === 'string' && d.fecha >= desde);
}

const SLOTS_PLATO = new Set(['comida', 'cena']);

export function capitalizarTexto(texto) {
  const s = String(texto || '').trim();
  if (!s) return '';
  return s.charAt(0).toLocaleUpperCase('es-ES') + s.slice(1);
}

function leerPlato(dia, slot) {
  return {
    texto: dia?.[slot] == null ? '' : String(dia[slot]),
    forzada: !!dia?.[`${slot}Forzada`],
    sinIngredientes: !!dia?.[`${slot}SinIngredientes`],
    href: dia?.[`${slot}Href`] ?? null,
    congelada: !!dia?.[`${slot}Congelada`],
  };
}

function conPlato(dia, slot, plato) {
  return {
    ...dia,
    [slot]: plato.texto,
    [`${slot}Forzada`]: plato.forzada,
    [`${slot}SinIngredientes`]: plato.sinIngredientes,
    [`${slot}Href`]: plato.href,
    [`${slot}Congelada`]: plato.congelada,
  };
}

export function intercambiarPlatos(dias, origen, destino) {
  const list = Array.isArray(dias) ? dias : [];
  if (!origen || !destino) return list;
  if (!SLOTS_PLATO.has(origen.slot) || !SLOTS_PLATO.has(destino.slot)) return list;
  if (origen.fecha === destino.fecha && origen.slot === destino.slot) return list;

  const idxA = list.findIndex((d) => d && d.fecha === origen.fecha);
  const idxB = list.findIndex((d) => d && d.fecha === destino.fecha);
  if (idxA < 0 || idxB < 0) return list;

  const platoA = leerPlato(list[idxA], origen.slot);
  const platoB = leerPlato(list[idxB], destino.slot);

  if (idxA === idxB) {
    const dia = conPlato(conPlato(list[idxA], origen.slot, platoB), destino.slot, platoA);
    return list.map((d, i) => (i === idxA ? dia : d));
  }

  return list.map((d, i) => {
    if (i === idxA) return conPlato(d, origen.slot, platoB);
    if (i === idxB) return conPlato(d, destino.slot, platoA);
    return d;
  });
}

export function describirIntercambio(origen, destino) {
  const oSlot = origen?.slot === 'cena' ? 'cena' : 'comida';
  const dSlot = destino?.slot === 'cena' ? 'cena' : 'comida';
  const oDia = capitalizarTexto(origen?.weekday || origen?.fecha || 'día');
  const dDia = capitalizarTexto(destino?.weekday || destino?.fecha || 'día');
  if (origen?.fecha && origen.fecha === destino?.fecha) {
    return `Intercambiadas la ${oSlot} y la ${dSlot} del ${oDia}.`;
  }
  return `Intercambiada la ${oSlot} del ${oDia} con la ${dSlot} del ${dDia}.`;
}

export function platoEsMovible({ editando = false, intercambiando = false } = {}) {
  return Boolean(editando) && !intercambiando;
}

export function platoConEnlace(texto, href) {
  const label = texto == null ? '' : String(texto);
  const link = href == null ? '' : String(href);
  const interno = Boolean(link.trim() && link.startsWith('/recetas'));
  return {
    texto: label,
    href: link || null,
    tieneEnlace: Boolean(label.trim() && link.trim()),
    interno,
  };
}
